import { render, staticRenderFns } from "./channelFeeNotice.vue?vue&type=template&id=69e68fc4&scoped=true&"
import script from "./channelFeeNotice.vue?vue&type=script&lang=js&"
export * from "./channelFeeNotice.vue?vue&type=script&lang=js&"
import style0 from "./channelFeeNotice.vue?vue&type=style&index=0&id=69e68fc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e68fc4",
  null
  
)

export default component.exports